import cn from 'classnames';
import { FC } from 'react';
import { FormattedMessage } from 'react-intl';

import { Button, Icon, Popup } from '@/shared/ui';

import { getDisplayToothNumber } from '@/entities/tooth';

import {
  LOWER_JAW_PERMANENT,
  LOWER_JAW_PRIMARY,
  UPPER_JAW_PERMANENT,
  UPPER_JAW_PRIMARY,
} from '../../config/constatnts';
import { ChangeToothNumberPopupProps } from '../../config/types';

import styles from './ChangeToothNumberPopup.module.scss';

export const ChangeToothNumberPopup: FC<ChangeToothNumberPopupProps> = ({
  className,
  isOpen,
  title,
  selectedTooth,
  dentalNotationFormat,
  onChangeToothNumber,
  onRemoveTooth,
  animatedToothNumber,
  selectTooth,
  pendingNumber,
}) => {
  const teethNumbers = [...UPPER_JAW_PERMANENT, ...LOWER_JAW_PERMANENT];
  const teethNumbersPrimary = [...UPPER_JAW_PRIMARY, ...LOWER_JAW_PRIMARY];

  const handleNumberClick = (num: number) =>
    onChangeToothNumber(selectedTooth, num);

  const handleClose = () => selectTooth(undefined);

  return (
    <Popup
      isOpen={isOpen}
      className={className}
      overlayClassname={styles.popupOverlay}
      bodyClassname={styles.toothNumberPopupBody}
      showHeader={false}
      onClose={handleClose}
      withoutPortal
    >
      <div className={styles.heading}>
        <h2 className={styles.title}>{title}</h2>
        <Icon
          className={styles.closeBtn}
          name="close"
          size={40}
          onClick={handleClose}
        />
      </div>

      <div className={styles.teeth}>
        {teethNumbers.map((num) => (
          <div
            key={num}
            className={cn('p3', styles.number, {
              [styles.selected]:
                !(
                  pendingNumber === -1 ||
                  (!pendingNumber && selectedTooth?.isRemoved)
                ) && (pendingNumber || selectedTooth?.ISONumber) === num,
            })}
            onClick={() => handleNumberClick(num)}
          >
            {getDisplayToothNumber(num, dentalNotationFormat)}
          </div>
        ))}
      </div>

      <div className={styles.primaryTeeth}>
        {teethNumbersPrimary.map((num) => (
          <div
            key={num}
            className={cn('p3', styles.number, {
              [styles.animated]: animatedToothNumber === num,
              [styles.selected]: selectedTooth?.ISONumber === num,
            })}
            onClick={() => handleNumberClick(num)}
          >
            {getDisplayToothNumber(num, dentalNotationFormat)}
          </div>
        ))}
      </div>

      <div className={styles.footer}>
        <Button
          size="medium"
          onClick={() => onRemoveTooth && onRemoveTooth(selectedTooth)}
          icon="delete"
          variant="secondary"
          danger
        >
          <FormattedMessage id="patient.remove" defaultMessage="Remove" />
        </Button>
      </div>
    </Popup>
  );
};
